<template>
  <footer class="footer">
    <div class="footer_top">
      <div class="comWidth">
        <ul>
          <!--澳门极草-->
          <!--澳门极草-->
          <li>
            <h5>澳門極草</h5>
            <a v-for="item in aomenList" :key="item.id" @click="goMacaoPage(item)">
              <span>{{item.title }}</span>
            </a>
            <router-link :to="{name:'MacaoPage',query:{id:5}}" tag="a">
              <span>企業簡介</span>
            </router-link>
            <router-link :to="{name:'MacaoPage',query:{id:84}}" tag="a">
              <span>聯系我們</span>
            </router-link>
          </li>
   <!--       <li>
            <h5>{{macaoList.name}}</h5>
            <a v-for="item in aomenList" :key="item.id" @click="goMacaoPage(item)">
              <span>{{item.title }}</span>
            </a>
          </li>-->

          <!--极草产品-->
          <li>
            <h5>{{productList.titles}}</h5>
            <a v-for="item in productList.titleChild" >
              <router-link :to="{name:item.src}" tag="span">{{item.name}}</router-link>
            </a>
          </li>
<!--
          &lt;!&ndash;冬蟲夏草&ndash;&gt;
          <li>
            <h5>{{dongList.name}}</h5>
            <a v-for="item in dongList.children" :key="item.id" @click="goDong(item)">
              <span>{{item.name}}</span>
            </a>
          </li>

          &lt;!&ndash;购物指南&ndash;&gt;
          <li>
            <h5>{{shopList.name}}</h5>
            <a v-for="item in shopList.children" :key="item.id" @click="goShop(item)">
              <span>{{item.name}}</span>
            </a>
          </li>

          &lt;!&ndash;極草資訊&ndash;&gt;
          <li>
            <h5>{{information.name}}</h5>
            <a v-for="item in information.children" :key="item.id" @click="goInformation(item)">
              <span>{{item.name}}</span>
            </a>
          </li>-->
          <li v-for="item in article" :key="item.id">
            <h5>{{item.name}}</h5>
            <a v-for="list in item.children" :key="list.id" @click="goArticleList(item,list)">
              <span>{{list.name}}</span>
            </a>
          </li>
        </ul>
        <div class="contact">
          <h5>聯系我們</h5>
          <p>
							<span>
								<img src="../assets/footer-phone.png" >
								{{cfg_contact_number}}
							</span>
          </p>
          <div class="footer_service">
            電子郵件 <br>
            {{cfg_contact_email}}
            <span>服務時間：9:00-18:00</span>
          </div>
          <img class="ims" :src="cfg_qr_code">
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  //common.js
  import { getLocalStorage} from '@/utils/common';
  //api
//  import {journalism ,newsClassificationList , dongClassificationList,allLists } from '@/api/article';
  import {articleCats} from '@/api/article';
  import {configs } from '@/api/other';
export default {
  name: 'Footer',
  data () {
    return {
  /*    footerLIst:[
            {
              titles:'澳門極草' ,
              titleChild:[{name:'企業簡介',src:'MacaoPage'},{name:'聯系我們',src:''}]
            },
            {
              titles:'極草產品' ,
              titleChild:[
                {name:'極草·5X冬蟲夏草純粉片',src:'ProductPage'},
                {name:'冬蟲夏草純粉片服用建議',src:''},
                {name:'產品防偽查詢',src:''}]
            },
            {
              titles:'冬蟲夏草' ,
              titleChild:[
                {name:'中西醫說蟲草',src:'CordycepsSinensis'},
                {name:'科學吃法',src:''},
                {name:'適宜人群',src:''},
                {name:'科普知識',src:''},
                {name:'臨床研究',src:''},
                {name:'行業資訊',src:''}
              ]
            },
            {
              titles:'購物指南' ,
              titleChild:[
                {name:'支付安全',src:'SecurityPayment'},
                {name:'物流配送',src:''},
                {name:'售後服務',src:''},
                {name:'其他問題',src:''}
              ]
            },
            {
              titles:'極草資訊' ,
              titleChild:[
                {name:'媒體報道',src:'InformationPage'},
                {name:'品牌榮譽',src:''}
              ]
            },

          ]*/
       //澳门极草
      macaoList:{
//        titles:'澳門極草' ,
//        titleChild:[{name:'企業簡介',src:'MacaoPage'},{name:'聯系我們',src:'ContactUs'}]
        },
      //极草产品
      productList: {
          titles:'極草產品' ,
          titleChild:[
            {name:'極草·5X冬蟲夏草純粉片',src:'ProductPage'},
            {name:'冬蟲夏草純粉片服用建議',src:'SuggestionTaking'},
            {name:'產品防偽查詢',src:'SecurityCheck'}]
        },
      //购物指南
      shopList: {},
       //极草咨询
      information:[],
      //冬虫夏草
      dongList:[],
      //所有列表数据
      getList:[],
      //极草id
      jiId:'',
      //澳门极草列表
      aomenList:[],
      //平台信息
      configsMsgFooter:{},
      cfg_contact_number:'',//电话
      cfg_contact_email:'',//邮箱
      cfg_qr_code:'',//二维码


      article:[] // 文章底部列表
    }
  },

  methods:{
/*    /!*获取极草咨询分类列表*!/
    getJournalismList(){
      newsClassificationList().then(res=>{
        this.information = res.data.data;
      });
    },*/

/*    /!*进入澳門極草页面*!/
    goMacaoPage(item){
        this.$router.push({
          name:'MacaoPage',
          query:{
              id:item.id,
            jiId:this.jiId
          }
        })
      sessionStorage.setItem('maCao' , JSON.stringify(item))
    },

    /!*进入极草咨询列表页面*!/
    goInformation(item){
        this.$router.push({
          name:'InformationPage',
          query:{
              id:item.id
          }
        })
    },

/!*    /!*冬蟲夏草分类列表*!/
    getDongList(){
      dongClassificationList().then(res=>{
        this.dongList = res.data.data;
      });
    },*!/

    /!*进入冬蟲夏草列表页面*!/
    goDong(item){
      this.$router.push({
        name:'CordycepsSinensis',
        query:{
          id:item.id
        }
      })
    },

    /!*进入购物指南列表页面*!/
    goShop(item){
      this.$router.push({
        name:'ShoppingSafety',
        query:{
          id:item.id
        }
      })
    },*/

    /*进入新闻详情*/
    goArticleList(item,list){
        if(item.id === 1){ // 极草咨询
          this.$router.push({
            name:'InformationPage',
            query:{
              id:list.id
            }
          })
        }
        if(item.id === 2){
          this.$router.push({ // 冬虫夏草
            name:'CordycepsSinensis',
            query:{
              id:list.id
            }
          })
        }
        if(item.id === 3){
          this.$router.push({ // 購物指南
            name:'ShoppingSafety',
            query:{
              id:list.id
            }
          })
        }
        if(item.id === 4){
          this.jiId = 24
          this.$router.push({ // 澳門極草
            name:'MacaoPage',
            query:{
              id:list.id,
              jiId:this.jiId
            }
          })
        }
    },

    /*获取所有列表*/
    getAllLists(){
/*      allLists().then(res =>{
          this.getList = res.data.data;
          this.macaoList = res.data.data[3];
          this.jiId = res.data.data[3].id;
          this.dongList = res.data.data[1];
          this.shopList = res.data.data[2];
          this.information = res.data.data[0];
          //请求澳门极草
          var obj = {
            include:'articlecat',
            article:this.jiId
          }
          journalism(obj).then(res =>{
              this.aomenList = res.data.data;

          })
      })*/
      articleCats({show_in_nav:1}).then(res =>{
        this.article = res.data.data
      })
    },

    /*获取平台信息*/
    getConfigs(){
      this.configsMsgFooter = JSON.parse(sessionStorage.getItem('configsMsgFooter'));
      if (!this.configsMsgFooter){
        configs().then(res =>{
          this.configsMsgFooter = res.data;
          this.cfg_contact_number = this.configsMsgFooter.cfg_contact_number;
          this.cfg_contact_email = this.configsMsgFooter.cfg_contact_email;
          this.cfg_qr_code = this.configsMsgFooter.cfg_qr_code;
          sessionStorage.setItem('configsMsgFooter' , JSON.stringify( this.configsMsgFooter))
        })
      }
      else{
        getLocalStorage('configsMsgFooter' , res =>{
          this.configsMsgFooter = res;
          this.cfg_contact_number = this.configsMsgFooter.cfg_contact_number;
          this.cfg_contact_email = this.configsMsgFooter.cfg_contact_email;
          this.cfg_qr_code = this.configsMsgFooter.cfg_qr_code;
        })
      }
    },
/*    getMSG(){
      getLocalStorage('configsMsgFooter' , res =>{
        this.cfg_contact_number = this.configsMsgFooter.cfg_contact_number;
        this.cfg_contact_email = this.configsMsgFooter.cfg_contact_email;
        this.cfg_qr_code = this.configsMsgFooter.cfg_qr_code;
      })
    }*/
  },
  created(){
/*    //获取极草咨询分类列表
    this.getJournalismList();
    //获取极草咨询分类列表
    this.getDongList();*/
    this.getAllLists();
    //平台信息
    this.getConfigs();
//    this.getMSG();
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "../css/footer.less";
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue